import { render, staticRenderFns } from "./DoKoDialogGameMode.vue?vue&type=template&id=af035dd2&scoped=true&"
import script from "./DoKoDialogGameMode.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogGameMode.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogGameMode.vue?vue&type=style&index=0&id=af035dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af035dd2",
  null
  
)

export default component.exports